import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/$campaignId/')({
	loader: async ({ params }) => {
		const { companyId, campaignId } = params
		throw redirect({
			to: '/company/$companyId/$campaignId/overview',
			params: { companyId, campaignId },
		})
	},
})
